import ModalCategories from './ModalCategories';

export default ModalCategories;
